// components/LeadFormModal.tsx — modal wrapper around LeadForm.
// Used to replace inline `bartoszgaca.pl/fit-call` CTAs in pages/*AiPage.tsx (Phase 1.1).

import React, { useState } from 'react';
import { LeadForm } from './LeadForm';

interface LeadFormModalProps {
    productSlug?: string;
    triggerLabel?: string;
    triggerClassName?: string;
}

export const LeadFormModal: React.FC<LeadFormModalProps> = ({
    productSlug,
    triggerLabel = 'Umów rozmowę',
    triggerClassName = 'inline-block bg-primary-light dark:bg-primary-dark text-white py-3 px-6 rounded-full font-semibold hover:opacity-90 transition-opacity',
}) => {
    const [open, setOpen] = useState(false);

    return (
        <>
            <button type="button" onClick={() => setOpen(true)} className={triggerClassName}>
                {triggerLabel}
            </button>

            {open && (
                <div
                    className="fixed inset-0 z-[10000] bg-black/60 flex items-center justify-center p-4"
                    onClick={() => setOpen(false)}
                    role="dialog"
                    aria-modal="true"
                >
                    <div
                        className="bg-white dark:bg-gray-900 rounded-2xl max-w-md w-full p-6 shadow-2xl relative"
                        onClick={e => e.stopPropagation()}
                    >
                        <button
                            type="button"
                            onClick={() => setOpen(false)}
                            className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 dark:hover:text-gray-200 text-2xl leading-none"
                            aria-label="Zamknij"
                        >
                            ×
                        </button>
                        <h2 className="text-xl font-bold mb-1">Zostaw kontakt</h2>
                        <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
                            Odpisujemy w ciągu kilku godzin (pn-pt). Możesz też napisać od razu na WhatsApp.
                        </p>
                        <LeadForm
                            productSlug={productSlug}
                            onSubmitted={(_id, waUrl) => {
                                if (waUrl) {
                                    // optional: auto-redirect to WA after 3s
                                    setTimeout(() => { window.open(waUrl, '_blank'); }, 3000);
                                }
                            }}
                        />
                    </div>
                </div>
            )}
        </>
    );
};
